import React, { useState } from 'react'
import * as tableStyles from '../../styles/project-modules/table.module.less'

// TODO: Style for mobile
/**
 *
 * @param data Array of objects over which to map for rows
 * @param useKeys Array of keys to use as headers
 */

function Table({ data, useKeys, type = 'votes' }) {
  let [isExpanded, setIsExpanded] = useState(false)
  // console.log(data)
  return (
    <>
      <table className={`${tableStyles.table} ${tableStyles[type]}`}>
        <thead>
          <tr>
            {useKeys.map((key) => (
              <th>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data
            .filter((d, i) => (isExpanded ? true : i < 5))
            .map((item) => (
              <tr className={item.Lawmaker.props.className}>
                {useKeys.map((key) => (
                  <td>{item[key]}</td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
      {data.length > 5 && (
        <button
          className={tableStyles.btn}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Collapse -' : `Expand +`}
        </button>
      )}
    </>
  )
}

export default Table
